/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCredentialExpirationCheck extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCredentialExpirationCheck");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCredentialExpirationCheck.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCredentialExpirationCheck>): BackgroundJobPayloadForPeriodicCredentialExpirationCheck {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCredentialExpirationCheck(), model);
        BackgroundJobPayloadForPeriodicCredentialExpirationCheck.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCredentialExpirationCheck>): BackgroundJobPayloadForPeriodicCredentialExpirationCheck {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCredentialExpirationCheck.newInstance(<BackgroundJobPayloadForPeriodicCredentialExpirationCheck> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCredentialExpirationCheck) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCredentialExpirationCheck.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCredentialExpirationCheck): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCredentialExpirationCheck.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
